import React from 'react';

export default function renderIcon({ width = 89, height = 89 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 50 50"
      xmlSpace="preserve"
    >
      <defs>
        <linearGradient id="musicGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4b1e78" stopOpacity="0.7" />
          <stop offset="50%" stopColor="#7D6099" stopOpacity="0.9" />
          <stop offset="100%" stopColor="#DED0EB" stopOpacity="1" />
        </linearGradient>
      </defs>
      
      {/* Sound waves */}
      <g stroke="#4b1e78" strokeWidth="1.5" fill="none" strokeLinecap="round" opacity="0.6">
        <circle cx="25" cy="25" r="12">
          <animate attributeName="r" values="8;16;8" dur="2s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.8;0.2;0.8" dur="2s" repeatCount="indefinite" />
        </circle>
        <circle cx="25" cy="25" r="18">
          <animate attributeName="r" values="14;22;14" dur="2s" begin="0.5s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.6;0.1;0.6" dur="2s" begin="0.5s" repeatCount="indefinite" />
        </circle>
        <circle cx="25" cy="25" r="24">
          <animate attributeName="r" values="20;28;20" dur="2s" begin="1s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.4;0.05;0.4" dur="2s" begin="1s" repeatCount="indefinite" />
        </circle>
      </g>
      
      {/* Musical staff lines */}
      <g stroke="#4b1e78" strokeWidth="0.8" opacity="0.4">
        <line x1="15" y1="18" x2="35" y2="18" />
        <line x1="15" y1="21" x2="35" y2="21" />
        <line x1="15" y1="24" x2="35" y2="24" />
        <line x1="15" y1="27" x2="35" y2="27" />
        <line x1="15" y1="30" x2="35" y2="30" />
      </g>
      
      {/* Rotating musical notes */}
      <g fill="url(#musicGradient)" transform-origin="25 25">
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="0 25 25;360 25 25"
          dur="3s"
          repeatCount="indefinite"
        />
        
        {/* Quarter Note ♪ */}
        <g transform="translate(32, 20)" opacity="0.9">
          <ellipse cx="0" cy="3" rx="2.5" ry="1.8" fill="#4b1e78" />
          <rect x="2.2" y="-5" width="0.8" height="8" fill="#4b1e78" />
        </g>
        
        {/* Eighth Note ♫ */}
        <g transform="translate(18, 30)" opacity="0.9">
          <ellipse cx="0" cy="3" rx="2.2" ry="1.6" fill="#4b1e78" />
          <rect x="2" y="-4" width="0.7" height="7" fill="#4b1e78" />
          <path d="M2.7,-4 Q5,-3 6,-1 Q4,0 2.7,-1" fill="#4b1e78" />
        </g>
        
        {/* Sixteenth Note ♬ */}
        <g transform="translate(30, 32)" opacity="0.9">
          <ellipse cx="0" cy="2" rx="2" ry="1.4" fill="#4b1e78" />
          <rect x="1.8" y="-3" width="0.6" height="5" fill="#4b1e78" />
          <path d="M2.4,-3 Q4.5,-2 5.5,0 Q3.5,1 2.4,0" fill="#4b1e78" />
          <path d="M2.4,-1.5 Q4,-1 4.8,0.5 Q3.2,1.2 2.4,0.5" fill="#4b1e78" />
        </g>
        
        {/* Half Note ♩ */}
        <g transform="translate(22, 18)" opacity="0.8">
          <ellipse cx="0" cy="2" rx="2.3" ry="1.5" fill="none" stroke="#4b1e78" strokeWidth="0.8" />
          <rect x="2" y="-4" width="0.7" height="6" fill="#4b1e78" />
        </g>
        
        {/* Whole Note ○ */}
        <g transform="translate(28, 28)" opacity="0.7">
          <ellipse cx="0" cy="0" rx="2.8" ry="1.8" fill="none" stroke="#7D6099" strokeWidth="0.9" />
        </g>
      </g>
      
      {/* Central musical symbol */}
      <g fill="#4b1e78" transform="translate(25, 25)" opacity="0.9">
        <animate attributeName="opacity" values="0.7;1;0.7" dur="2s" repeatCount="indefinite" />
        <animate attributeName="transform" values="translate(25, 25) scale(1);translate(25, 25) scale(1.1);translate(25, 25) scale(1)" dur="2s" repeatCount="indefinite" />
        
        {/* Sharp symbol ♯ */}
        <g>
          <rect x="-0.3" y="-4" width="0.6" height="8" />
          <rect x="1.2" y="-4" width="0.6" height="8" />
          <rect x="-2" y="-1.5" width="5" height="0.6" />
          <rect x="-2" y="0.9" width="5" height="0.6" />
        </g>
      </g>
      
      {/* Floating musical note particles */}
      <g>
        {/* Small quarter note */}
        <g fill="#7D6099" transform="translate(15, 15)">
          <ellipse cx="0" cy="1" rx="1" ry="0.7" />
          <rect x="0.8" y="-1.5" width="0.3" height="2.5" />
          <animate attributeName="transform" values="translate(15, 15);translate(15, 12);translate(15, 15)" dur="2.5s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.3;0.8;0.3" dur="2.5s" repeatCount="indefinite" />
        </g>
        
        {/* Small eighth note */}
        <g fill="#7D6099" transform="translate(35, 35)">
          <ellipse cx="0" cy="1" rx="0.8" ry="0.6" />
          <rect x="0.7" y="-1" width="0.25" height="2" />
          <path d="M0.95,-1 Q1.8,-0.5 2,0.2 Q1.3,0.5 0.95,0" />
          <animate attributeName="transform" values="translate(35, 35);translate(35, 32);translate(35, 35)" dur="2.8s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.3;0.8;0.3" dur="2.8s" repeatCount="indefinite" />
        </g>
        
        {/* Small note head */}
        <g fill="#DED0EB" transform="translate(38, 18)">
          <ellipse cx="0" cy="0" rx="0.6" ry="0.4" />
          <animate attributeName="transform" values="translate(38, 18);translate(38, 15);translate(38, 18)" dur="3.2s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.2;0.7;0.2" dur="3.2s" repeatCount="indefinite" />
        </g>
      </g>
    </svg>
  );
}
